export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_07.b0c9d011.jpg";